import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";
import { ApparelProduct } from "@/types";
import { ProductGallery } from "./product-details/ProductGallery";
import { ProductInfo } from "./product-details/ProductInfo";
import { ProductControls } from "./product-details/ProductControls";

interface ProductDetailsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  product: ApparelProduct | null;
  onAddToCart: (product: ApparelProduct, quantity?: number, size?: string) => void;
}

const ProductDetailsDialog: React.FC<ProductDetailsDialogProps> = ({
  open,
  onOpenChange,
  product,
  onAddToCart,
}) => {
  const [quantity, setQuantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState<string>("");
  const [addedToCart, setAddedToCart] = useState(false);

  useEffect(() => {
    if (open) {
      setQuantity(1);
      setSelectedSize("");
      setAddedToCart(false);
    }
  }, [open]);

  if (!product) return null;

  const handleAddToCart = () => {
    if (product.requires_size && !selectedSize) {
      return;
    }

    onAddToCart(product, quantity, selectedSize || undefined);
    setAddedToCart(true);

    setTimeout(() => {
      setAddedToCart(false);
    }, 2000);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-xl p-0 overflow-auto max-h-[90vh] md:max-h-[85vh] rounded-xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-0">
          <div className="sm:max-h-[600px]">
            <ProductGallery product={product} />
          </div>
          
          <div className="p-4 sm:p-6 flex flex-col overflow-y-auto max-h-[50vh] sm:max-h-[600px]">
            <ProductInfo product={product} />
            
            <div className="mt-auto pt-4">
              <ProductControls
                product={product}
                quantity={quantity}
                selectedSize={selectedSize}
                addedToCart={addedToCart}
                onQuantityChange={setQuantity}
                onSizeSelect={setSelectedSize}
                onAddToCart={handleAddToCart}
              />
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ProductDetailsDialog;
